import types from '../types/delivery'
import {TIMESLOT, RENT} from '../../../endpoints'
import {apiPrivate} from '../../../api'
import simpleSnackbarActions from '../../../common/actions/simpleSnackbar'
import {push} from 'react-router-redux'
import {endpoint as endpointText} from '../../../common/text'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class delivery {

  static selectDate(date) {
    return function(dispatch, getState) {

      const startDate = getState().ui.rent.orchestrator.getIn(['rent', 'StartDate'])
      const value = date === null ? startDate : date

      dispatch({
        type: types.SELECT_DATE,
        payload: {
          date: value,
        },
      })
      return dispatch(delivery.getTimeslots(value))
    }
  }

  static getUnavailableDates() {
    return function(dispatch) {

      dispatch({type: types.GET_UNAVAILABLE_DATES})

      return apiPrivate.get(TIMESLOT + '/timeSlot/occupiedDates?daysOnwards=90')
        .then(response => {
          dispatch(delivery.getUnavailableDatesSuccess(response.data.description))
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(delivery.getUnavailableDatesFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(delivery.getUnavailableDatesFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
        })
    }
  }

  static getUnavailableDatesSuccess(data) {
    return {
      type: types.GET_UNAVAILABLE_DATES_SUCCESS,
      payload: {
        dates: data, //TODO must test, api is currently returning empty array
      },
    }
  }

  static getUnavailableDatesFail(error) {
    return {
      type: types.GET_UNAVAILABLE_DATES_FAIL,
      payload: {
        error,
      },
    }
  }

  static selectTimeslot(timeslot) {
    return {
      type: types.SELECT_TIMESLOT,
      payload: {
        timeslot,
      },
    }
  }

  static getTimeslots(date) {
    return function(dispatch, getState) {

      const lastTimeslotFetchID = (new Date()).getMilliseconds()
      dispatch({
        type: types.GET_TIMESLOTS,
        payload: {
          lastTimeslotFetchID,
        },
      })

      return apiPrivate.get(TIMESLOT + '/timeSlot?date=' + date.format('X'))
        .then(response => {
          if (lastTimeslotFetchID === getState().ui.rent.delivery.get('lastTimeslotFetchID')) {
            dispatch(delivery.getTimeslotsSuccess(response.data.description))
          }
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(delivery.getTimeslotsFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(delivery.getTimeslotsFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
        })
    }
  }

  static getTimeslotsSuccess(data) {
    return {
      type: types.GET_TIMESLOTS_SUCCESS,
      payload: {
        timeslots: data,
      },
    }
  }

  static getTimeslotsFail(error) {
    return {
      type: types.GET_TIMESLOTS_FAIL,
      payload: {
        error,
      },
    }
  }

  static modifyTransaction() {
    return function(dispatch, getState) {

      const state = getState().ui.rent.delivery

      const rent = getState().ui.rent.orchestrator.getIn(['rent', 'ID'])
      const timeslotId = state.get('timeslot')
      const date = state.get('date')

      if (timeslotId === 0 || date === null) {
        dispatch(delivery.modifyTransactionFail(''))
        return Promise.reject(null)
      }

      dispatch({type: types.MODIFY_TRANSACTION})

      const data = new FormData()
      data.append('time_slot_start_date', timeslotId)
      data.append('start_date', date.format('X'))

      return apiPrivate.put(RENT + '/rent/' + rent, data)
        .then(response => {
          dispatch(delivery.modifyTransactionSuccess(date, state.get('timeslots').find(t => t.get('ID') === timeslotId)))
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(delivery.modifyTransactionFail(message))
              return Promise.reject(null)
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(delivery.modifyTransactionFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
          return Promise.reject(null)
        })
    }
  }

  static modifyTransactionSuccess(date, timeslot) {
    return {
      type: types.MODIFY_TRANSACTION_SUCCESS,
      payload: {
        date,
        timeslot,
      },
    }
  }

  static modifyTransactionFail(error) {
    return {
      type: types.MODIFY_TRANSACTION_FAIL,
      payload: {
        error,
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/sections/rent/actions/delivery.js